module.exports = __webpack_public_path__ + "img/05.a2e3a573.png";